import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import classNames from 'classnames';

import { withStyles } from '@material-ui/core/styles';
import withWidth from '@material-ui/core/withWidth';

import {
  expandMainNavigation,
  collapseMainNavigation,
  expandSettingsNavigation,
  collapseSettingsNavigation,
  expandPrintNavigation,
  collapsePrintNavigation,
} from 'redux/modules/routerParams';

import DefaultHeader from './DefaultHeader';
import LandingHeader from './LandingHeader';
import DefaultNavigation from './DefaultNavigation';
import SettingsNavigation from './SettingsNavigation';
import PrintNavigation from './PrintNavigation';
import LandingFooter from './LandingFooter';

const styles = theme => ({
  root: {
    position: 'relative',
    boxSizing: 'border-box',
    backgroundColor: theme.palette.grey['100'],
    minHeight: '100%',
    // height: '100%',
    // minWidth: 1270,
    padding: '64px 0 0 132px',
    // overflow: 'auto',
    // overflow: 'hidden',
    transition: theme.transitions.create(['padding'], {
      duration: theme.transitions.duration.short,
    }),
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 0,
      left: 48,
      transition: theme.transitions.create(['left'], {
        duration: theme.transitions.duration.short,
      }),
    },
  },
  rootMainNavigationCollapsed: {
    paddingLeft: 48,
    [theme.breakpoints.down('sm')]: {
     left: 0,
     paddingLeft: 0,
    },
  },
  
  rootSettings: {
    paddingLeft: 265,
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 0,
      left: 48,
      transition: theme.transitions.create(['left'], {
        duration: theme.transitions.duration.short,
      }),
    },
  },
  rootSettingsNavigationCollapsed: {
    left: 0,
    [theme.breakpoints.down('sm')]: { 
      left: 0,
    },
  },
  rootError: {
    backgroundColor: theme.palette.common.white,
    paddingLeft: 0,
  },
  rootPrint: {
    paddingLeft: 290,
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 0,
      left: 290,
      transition: theme.transitions.create(['left'], {
        duration: theme.transitions.duration.short,
      }),
    },
  },
  rootPrintNavigationCollapsed: {
    [theme.breakpoints.down('sm')]: {
      left: 0,
    },
  },
  rootAccountLogin: {
    backgroundColor: theme.palette.common.white,
    paddingTop: 0,
    paddingLeft: 0,
    minWidth: 0,
    '&:before': {
      content: '""',
      position: 'absolute',
      top: '50%',
      right: '58%',
      transform: 'translateY(-50%)',
      height: 0,
      width: '116.79%',
      paddingTop: '116.79%',
      borderRadius: '50%',
      background: `linear-gradient(
        329.68deg, ${theme.palette.primary[100]} 0%,
        ${theme.palette.primary[950]} 100%
      )`,
    },
    '&:after': {
      content: '""',
      position: 'absolute',
      top: '50%',
      right: '58%',
      transform: 'translateY(-50%)',
      height: 0,
      width: '65.69%',
      paddingTop: '65.69%',
      borderRadius: '50%',
      marginRight: '25.54%',
      background: theme.palette.common.white,
    },
    [theme.breakpoints.down('sm')]: {
      left: 0,
    },
  },
  rootAccountProfile: {
    backgroundColor: theme.palette.grey[100],
    paddingTop: 0,
    paddingLeft: 0,
  },
  rootLanding: {
    backgroundColor: theme.palette.common.white,
    paddingLeft: 0,
    minWidth: 0,
  },
  main: {
    position: 'relative',
    minHeight: 'calc(100vh - 114px)',
    padding: 16,
    [theme.breakpoints.down('sm')]: {
      padding: 8,
    },
  },
  mainLanding: {
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down('xs')]: {
      padding: 15,
    },
    '& $mainContent': {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: 'calc(100vh - 178px)',
    },
  },
  mainAccountLogin: {
    display: 'flex',
    flexDirection: 'column',
    paddingTop: 0,
    paddingBottom: 0,
    minHeight: '100vh',
    zIndex: 1,
    padding: '0 16px',
    [theme.breakpoints.up('sm')]: {
      padding: '0 30px',
    },
    '& $mainContent': {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh',
      boxSizing: 'border-box',
      paddingTop: 16,
      paddingBottom: 70,
      [theme.breakpoints.up('sm')]: {
        paddingTop: 25,
      },
    },
  },
  mainAccountProfile: {
    width: 1140,
    margin: '0 auto',
  },
  mainContent: {

  },
});

const Layout = ({
  variant,
  navigationSections,
  titleText,
  titleHref,
  subtitle,
  classes,
  children,
  width,
  actions,
  record,
  className,
  ...otherProps
}) => {
  let mainNavigationExpanded = true;
  let settingsNavigationExpanded = true;
  let printNavigationExpanded = true;
  if (otherProps.mainNavigationExpanded === undefined) {
    if (['xl', 'lg'].indexOf(width) !== -1) {
      mainNavigationExpanded = true;
    } else {
      mainNavigationExpanded = false;
    }
  } else {
    mainNavigationExpanded = otherProps.mainNavigationExpanded;
  }
  if (['xl', 'lg', 'md'].indexOf(width) !== -1) {
    settingsNavigationExpanded = true;
  } else {
    settingsNavigationExpanded = otherProps.settingsNavigationExpanded;
  }
  if (['xl', 'lg', 'md'].indexOf(width) !== -1) {
    printNavigationExpanded = true;
  } else {
    printNavigationExpanded = otherProps.printNavigationExpanded;
  }
  return (
    <div
      className={classNames(classes.root, className, {
        [classes.rootSettings]: variant === 'settings',
        [classes.rootError]: variant === 'error',
        [classes.rootAccountLogin]: variant === 'account-login',
        [classes.rootAccountProfile]: variant === 'account-profile',
        [classes.rootPrint]: variant === 'print',
        [classes.rootLanding]: variant === 'landing',
        [classes.rootMainNavigationCollapsed]: variant === 'default'
          && !mainNavigationExpanded,
        [classes.rootSettingsNavigationCollapsed]: variant === 'settings'
          && !settingsNavigationExpanded,
        [classes.rootPrintNavigationCollapsed]: variant === 'print'
          && !printNavigationExpanded,
      })}
    >
      {['account-login', 'account-profile', 'landing'].indexOf(variant) === -1 &&
        <DefaultHeader variant={variant} record={record} titleText={titleText} />
      }
      {variant === 'landing' &&
        <LandingHeader />
      }
      {variant === 'default' &&
        <DefaultNavigation
          onExpandCollapseButtonClick={() => {
            if (mainNavigationExpanded) {
              actions.collapseMainNavigation();
            } else {
              actions.expandMainNavigation();
            }
          }}
          expanded={mainNavigationExpanded}
        />
      }
      {variant === 'settings' &&
        <SettingsNavigation
          onExpandCollapseButtonClick={() => {
            if (settingsNavigationExpanded) {
              actions.collapseSettingsNavigation();
            } else {
              actions.expandSettingsNavigation();
            }
          }}
          expanded={settingsNavigationExpanded}
        />
      }
      {variant === 'print' &&
        <PrintNavigation
          sections={navigationSections}
          titleText={titleText}
          titleHref={titleHref}
          subtitle={subtitle}
          expanded={printNavigationExpanded}
          onExpandCollapseButtonClick={() => {
            if (printNavigationExpanded) {
              actions.collapsePrintNavigation();
            } else {
              actions.expandPrintNavigation();
            }
          }}
        />
      }
      <div
        className={classNames(classes.main, {
          [classes.mainAccountProfile]: variant === 'account-profile',
          [classes.mainAccountLogin]: variant === 'account-login',
          [classes.mainLanding]: variant === 'landing',
        })}
      >
        <div className={classes.mainContent}>
          {children}
        </div>
      </div>
      {variant === 'landing' &&
        <LandingFooter />
      }
    </div>
  );
};

Layout.propTypes = {
  variant: PropTypes.oneOf([
    'default',
    'settings',
    'error',
    'account-login',
    'account-profile',
    'print',
    'landing',
  ]),
  children: PropTypes.node,
  navigationSections: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string,
    items: PropTypes.arrayOf(PropTypes.shape({
      title: PropTypes.string,
      href: PropTypes.string,
    })),
  })),
  titleText: PropTypes.string,
  titleHref: PropTypes.string,
  mainNavigationExpanded: PropTypes.bool,
  actions: PropTypes.shape({
    expandMainNavigation: PropTypes.func.isRequired,
    collapseMainNavigation: PropTypes.func.isRequired,
  }).isRequired,
  width: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']).isRequired,
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    rootMainNavigationCollapsed: PropTypes.string.isRequired,
    rootSettings: PropTypes.string.isRequired,
    rootAccountLogin: PropTypes.string.isRequired,
    rootAccountProfile: PropTypes.string.isRequired,
    rootPrint: PropTypes.string.isRequired,
    rootPrintNavigationCollapsed: PropTypes.string.isRequired,
    rootLanding: PropTypes.string.isRequired,
    main: PropTypes.string.isRequired,
    mainLanding: PropTypes.string.isRequired,
    mainAccountProfile: PropTypes.string.isRequired,
    mainAccountLogin: PropTypes.string.isRequired,
    mainContent: PropTypes.string.isRequired,
  }).isRequired,
  className: PropTypes.string,
};

Layout.defaultProps = {
  children: '',
  variant: 'default',
  navigationSections: null,
  titleText: null,
  titleHref: null,
  mainNavigationExpanded: undefined,
  className: '',
};

const mapStateToProps = store => ({
  mainNavigationExpanded: store.routerParams.mainNavigationExpanded,
  settingsNavigationExpanded: store.routerParams.settingsNavigationExpanded,
  printNavigationExpanded: store.routerParams.printNavigationExpanded,
  record: store.routerParams.record || [],
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    expandMainNavigation,
    collapseMainNavigation,
    expandSettingsNavigation,
    collapseSettingsNavigation,
    expandPrintNavigation,
    collapsePrintNavigation,
  }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(
  withWidth()(withStyles(styles)(Layout)),
);



// WEBPACK FOOTER //
// ./src/components/common/Layout/Layout.js